/* EOK Shop — main.js (adapted from WP theme for Shopify) */

(function () {
  'use strict';

  /* ── Cart badge update ──────────────────────────────────────── */
  function updateCartBadges(count) {
    document.querySelectorAll(
      '#eok-cart-badge-mobil, #eok-cart-badge-desktop'
    ).forEach(function (el) {
      var inner = el.querySelector('.eok-cart-count');
      if (inner) { inner.textContent = count; } else { el.textContent = count; }
      el.style.display = count > 0 ? '' : 'none';
    });
  }
  /* Zentral nutzbar (z.B. von eok-pricing.js beim Init und vom Cart-Drawer) */
  window.eokUpdateCartBadges = updateCartBadges;

  /* ── Add to cart via AJAX + open drawer ─────────────────────── */
  window.eokAddToCart = function (variantId, quantity, itemMeta) {
    quantity = quantity || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadges(cart.item_count);
        document.dispatchEvent(new CustomEvent('eok:cart:updated', { detail: { cart: cart, itemMeta: itemMeta || null } }));
        var drawerEl = document.getElementById('eok-cart-drawer');
        if (drawerEl && window.bootstrap) {
          bootstrap.Offcanvas.getOrCreateInstance(drawerEl).show();
        }
        return cart;
      });
  };

  /* ── Tab title flicker (fun, harmless) ─────────────────────── */
  var originalTitle = document.title;
  document.addEventListener('visibilitychange', function () {
    document.title = document.hidden ? '👋 Wir vermissen dich!' : originalTitle;
  });

  /* ── Back-to-top button ─────────────────────────────────────── */
  var btn = document.getElementById('eok-backtotop');
  if (btn) {
    window.addEventListener('scroll', function () {
      btn.classList.toggle('show', window.scrollY > 400);
    });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Mobile nested submenu toggle ──────────────────────────── */
  document.querySelectorAll('.eok-submenu-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var submenuItem = btn.closest('.dropdown-submenu');
      submenuItem.classList.toggle('mobile-open');
      var icon = btn.querySelector('i');
      icon.classList.toggle('bi-chevron-down');
      icon.classList.toggle('bi-chevron-up');
    });
  });

  /* Klick auf Submenu-Link-Text → Submenu öffnen statt navigieren (nur Mobile) */
  document.querySelectorAll('.dropdown-submenu > .dropdown-item').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (window.innerWidth >= 1400) return;
      var btn = link.closest('.dropdown-submenu').querySelector('.eok-submenu-toggle');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.click();
    });
  });

  /* ── Auto-expand shop dropdown on mobile when on shop page ─── */
  var offcanvasNavEl = document.getElementById('offcanvasNavbar2');
  if (offcanvasNavEl) {
    offcanvasNavEl.addEventListener('show.bs.offcanvas', function () {
      if (window.innerWidth >= 1400) return;
      var shopToggle = offcanvasNavEl.querySelector('[data-eok-shop-toggle]');
      if (shopToggle) {
        var navItem = shopToggle.closest('.nav-item');
        var dropdownMenu = navItem ? navItem.querySelector('.dropdown-menu') : null;
        shopToggle.setAttribute('aria-expanded', 'true');
        if (navItem) navItem.classList.add('show');
        if (dropdownMenu) dropdownMenu.classList.add('show');
      }
    });
    offcanvasNavEl.addEventListener('hidden.bs.offcanvas', function () {
      var shopToggle = offcanvasNavEl.querySelector('[data-eok-shop-toggle]');
      if (shopToggle) {
        var navItem = shopToggle.closest('.nav-item');
        var dropdownMenu = navItem ? navItem.querySelector('.dropdown-menu') : null;
        shopToggle.setAttribute('aria-expanded', 'false');
        if (navItem) navItem.classList.remove('show');
        if (dropdownMenu) dropdownMenu.classList.remove('show');
      }
    });
  }

  /* Reset submenu state when parent dropdown closes */
  document.querySelectorAll('.nav-item.dropdown').forEach(function (item) {
    item.addEventListener('hide.bs.dropdown', function () {
      item.querySelectorAll('.dropdown-submenu').forEach(function (sub) {
        sub.classList.remove('mobile-open');
        var icon = sub.querySelector('.eok-submenu-toggle i');
        if (icon) {
          icon.classList.remove('bi-chevron-up');
          icon.classList.add('bi-chevron-down');
        }
      });
    });
  });

  /* Cart-Badge-Init + Coupon-Erkennung übernimmt eok-pricing.js (zentrales Modul). */
})();
